export const generateConsistentColor = (name: string): string => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 60%, 80%)`;
};

export const getTextColor = (backgroundColor: string): string => {
    return '#000000';
};

export const PillStyle: React.CSSProperties = {
    display: 'inline-block',
    padding: '4px 8px',
    margin: '2px',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: 500,
};
